import ConfirmationDialog from '@rio-cloud/rio-uikit/ConfirmationDialog';
import { FormattedMessage } from 'react-intl';

type MaterialTypeChangeConfirmationDialogProps = {
    show: boolean;
    onCancel: () => void;
    onConfirm: () => void;
};

export const MaterialTypeChangeConfirmationDialog = ({
    show,
    onCancel,
    onConfirm,
}: MaterialTypeChangeConfirmationDialogProps) => {
    return (
        <ConfirmationDialog
            show={show}
            title={
                <FormattedMessage id='intl-msg:ordercom-cloud-frontend.orders.create-dialog.material-type-change.confirm.title' />
            }
            content={
                <FormattedMessage id='intl-msg:ordercom-cloud-frontend.orders.create-dialog.material-type-change.confirm.content' />
            }
            cancelButtonText={
                <FormattedMessage id='intl-msg:ordercom-cloud-frontend.orders.create-dialog.material-type-change.confirm.cancel' />
            }
            confirmButtonText={
                <FormattedMessage id='intl-msg:ordercom-cloud-frontend.orders.create-dialog.material-type-change.confirm' />
            }
            onClickCancel={onCancel}
            onClickConfirm={onConfirm}
        />
    );
};
